export default "__VITE_ASSET__DWEIlY75__"